import { AbstractControl } from '@angular/forms';


export class CustomValidator {


    /**
     * @description
     * @date 2020-12-21
     * @static
     * @returns
     * @memberof CustomValidator
     */
    static checkIfAccountSelected() {
        return (control: AbstractControl) => {
            if (+control.value === -1) {
                return { 'required': true };
            } else {
                return null;
            }
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/customvalidation.component.ts